export const Vendors = {
  'GOOGLE': 'google',
  'MICROSOFT': 'microsoft',
  'APPLE': 'apple',
} as const;

export type Vendor = (typeof Vendors)[keyof typeof Vendors];